<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Listado de plantas</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  right
                 @click="dialog = !dialog"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar nueva planta</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  dark
                  right
                 @click="upload = !upload"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Carga masiva de plantas</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba para filtrar plantas"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table 
        :headers="facilitiesListHeaders"
        :items="facilitiesListBody"
        class="elevation-3 mt-5"
        no-data-text="No hay plantas"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editFacility(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar Planta</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
                medium
                @click="deleteFacility(item)"
                v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Eliminar Planta</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Modal New -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">
          Datos de la planta
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Nombre"
                v-model="facility.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveFacility"
              >Grabar</v-btn>
        </v-card-actions>
              
      </v-card>
    </v-dialog>
    <!-- / Modal New-->

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir listado de plantas
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="uploadFacilities"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal upload -->
    
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      errors: [],
      snackbar: false,
      color: 'green',
      validation_message: '',
      search: null,
      file: null,
      dialog: false,
      upload: false,
      facilityIndex: -1,
      facility: {
        id: 0,
        name: '',
      },
      facilitiesListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre Planta',
          align: 'left',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      facilitiesListBody: [],
    }),
    mounted() {
      this.loadFacilities();
    },
    methods:{
      async loadFacilities(){
        this.mostrarLoading('Cargando listado de plantas...');
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilitiesListBody = response.data.data;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      async saveFacility(){
        // validation
        this.errors = [];
        if(!this.facility.name){
          this.errors.push("Debe indicar nombre de la planta");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}facilities`;
        let facilityData = {
          'name': this.facility.name,
        };
        let response = null;
        if(this.facility.id > 0){
          url = url + "/" + this.facility.id;
          try{
            response = await this.axios.put(url, facilityData, this.headers);
            let index = this.facilitiesListBody.map(facility => {
              return facility.id;
            }).indexOf(this.facility.id);
            this.facilitiesListBody.splice(index, 1, response.data.data);
            this.dialog = false;
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
          }
        }else{
          try{
            response = await this.axios.post(url, facilityData, this.headers)
            this.facilitiesListBody.push(response.data.data);
            this.validation_message = "Grabado exitosamente!";
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
          }
        }
      },
      editFacility(item) {
        this.facilityIndex = this.facilitiesListBody.indexOf(item)
        this.facility = Object.assign({}, item)
        this.dialog = true
      },
      deleteFacility(item) {
        this.$confirm('Desea borrar este planta?').then(res => {
          if(res){
            const index = this.facilitiesListBody.indexOf(item);
            this.facilitiesListBody.splice(index, 1);
          }
        });
      },
      closeModal(){
        this.dialog = false;
        this.error = null;
        this.error_message = "";
        this.success = null;
        this.facility.name = "";
      },
      async uploadFacilities(){
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}facilities/upload`;
        let formData = new FormData();
        formData.append("excel", this.file);
        await this.axios.post(url, formData, this.headers).then((response)=>{
          console.log(response.data.data);
          this.file = null;
          this.upload = false;
          this.loadFacilities();
        }).catch((response)=>{
          if(response.success == false && response.message == "Validation Error"){
            console.log(response.data);
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
    },
    components:{
    }
  }
</script>